import { Close, Content, Overlay, Portal, Root, Trigger } from '@radix-ui/react-dialog';
import React, { ComponentProps, ElementRef, forwardRef } from 'react';
import { Icon } from '@/components/global/Icons';

const Sheet = Root;
const SheetTrigger = Trigger;

const SheetContent = forwardRef<ElementRef<typeof Content>, ComponentProps<typeof Content>>((props, forwardedRef) => (
    <Portal>
        <Overlay>
            <Content
                {...props}
                ref={forwardedRef}
                className="fixed top-0 left-0 z-50 overflow-y-scroll h-full bg-primary text-shell-25 w-full lg:w-auto lg:pr-32 lg:rounded-r-3xl shadow-lg data-[state=closed]:animate-nav-out data-[state=open]:animate-nav-in"
            >
                <div className="flex flex-col justify-between p-10">
                    <div>
                        <Close asChild>
                            <button aria-label="Close navigation menu" className="uppercase p small tracking-wide flex items-center">
                                <Icon id="cross" className="fill-white w-6 h-6 mr-2" />
                                Close
                            </button>
                        </Close>
                    </div>
                    <div>{props.children}</div>
                </div>
            </Content>
        </Overlay>
    </Portal>
));
SheetContent.displayName = 'SheetContent';

export { Sheet, SheetTrigger, SheetContent };
